import React, { useEffect, useRef, useState } from "react";
import { useFetching } from "../hooks/useFetching";
import Loader from "./UI/Loader/Loader";
import { Chart } from "react-google-charts";
import cl from "../styles/GoogleCharts.module.css";
import MyButton from "./UI/button/MyButton";
import MySelect from "./UI/select/MySelect";
import { defineFileDays, defineDayFile} from "../utils/logs";
import Spinner from "./UI/spinner/Spinner";
import ProgressBarDiv from "./UI/ProgressBarDiv/ProgressBarDiv";
import { useVariable } from "../hooks/useVariable";

const GCharts = () => {
  console.log("***************render****************");
  // const renderstart = new Date();

  const [loading, setLoading] = useState(false);
  const [remainLoad, setRemainLoad] = useState(0);
  const [loadProgress, setLoadProgress] = useState({ remain: 0, total: 0 });
  const [live, setLive] = useState(false);
  // const [liveValue, setLiveValue] = useState({});
  // const varNames = ['fit1', 'fit2', 'fit3', 'fit4', 'fit5'];
  // const variables = varNames.reduce((acc, name) => {
  //   acc[name] = useVariable(name);
  //   return acc;
  // }, {});
  // const varsSelected =

  const [varName, setVarName] = useState("");
  const [chartData, setChartData] = useState([["Time", "Value"]]);

  const dataRef = useRef(null);
  const now = new Date();
  const tA = new Date();
  tA.setTime(now.getTime() - 24 * 3600 * 1000);
  const [timeA, setTimeA] = useState(tA);
  const [timeB, setTimeB] = useState(new Date());

  

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  // console.log(`varName ${varName}`);

  const liveValue = useVariable(varName);
  // console.log(`liveValue ${liveValue}`);

  useEffect(() => { //updateliveValue
    if (!live) return;
    //add live value
    // console.log("live value changed: " + liveValue);
    const date = new Date();
    setChartData((prev) => [...prev, [date, liveValue]]);
    setTimeB(date);
    if (varName) {
      // console.log(`varName ${varName}`);
      const varRef = dataRef.current.get(varName);
      console.assert(varRef);
      if (varRef) {
        // console.log('try add latest value');
        // console.log(varRef);
        const latestChunk = varRef[varRef.length-1];
        // console.log(latestChunk);
      }
    }
  }, [live, liveValue]);

  useEffect(() => {
    console.clear();
    console.log("@ mount @ ");
    dataRef.current = new Map();
    setTimeB(new Date());
    const now = new Date();
    const tA = new Date();

    // tA.setTime(now.getTime() - 1 * 3600 * 1000);
    // setTimeA(tA);
    console.log(`A ${timeA}`);
    console.log(`B ${timeB}`);
  }, []);

  useEffect(() => { //main update
    console.log("@ update var or A or B  @");
    console.log(`A ${timeA}`);
    console.log(`B ${timeB}`);

    // const t1 = new Date();
    // // t1.setHours(2);
    // const fileName = defineDayFile(t1, 'var');
    // console.log(`test t:${t1} file ${fileName.name}`);
    

    console.log(`now   ${new Date()}`);
    // console.log(`old A ${timeA}`);
    // console.log(`old B ${timeB}`);
    if (timeA && timeB && varName) {
      const fetchData = async () => {
        let list = defineFileDays(timeA, timeB, varName);
        console.log(`days list length: ${list.length}`);
        // logRefDays(list);
        // console.log(list);
        mergeRefs(list);
        setLoading(true);
        await fetchLogs();
        setLoading(false);
        bakeDataForChart();
      };
      fetchData();
    } else {
      console.log("incifient data");
    }
  }, [varName, timeA, timeB]);

  const bakeDataForChart = () => {
    const bench1 = new Date();
    console.log("((((((((((((((BAKING))))))))))))))");

    const varRef = dataRef.current.get(varName);
    varRef.sort((a, b) => a.time - b.time);
    const rows = [["Second", "Value"]]; // Заголовок для графика
    varRef.forEach(({ data }) => {
      if (Array.isArray(data)) {
        rows.push(...data); // добавляем массивы [timeCode, value]
      }
    });
    console.log("rows count: " + rows.length);
    rows.push([new Date(), liveValue]);
    setChartData(rows);
    const bench2 = new Date();
    console.log(`Δt: ${bench2.getTime() - bench1.getTime()}`);
  };

  // useEffect(() => {
  //   bakeDataForChart();
  // }, [remainLoad]);

  const mergeRefs = (list) => {
    console.log("merging to Refs.current");
    const varRef = getOrCreate(varName);
    list.map((item) => {
      // console.log(`want push ${item} to refs:  ${varRef}`);
      // console.log(varRef);
      if (!varRef.some((el) => el.name === item.name)) {
        console.log(`push item ${item}`);
        varRef.push(item);
        item.fetched = false;
      } else {
        console.log("already in refs");
      }
    });

    console.log("////merged////");
  };

  const fetchLogs = async () => {
    console.log("fetch");
    if (!dataRef.current.has(varName)) {
      console.log("Assert: nothingTo fetch " + varName);
      return;
    }

    const varRef = dataRef.current.get(varName);

    // Устанавливаем начальное количество запросов, которые нужно выполнить
    const itemsToFetch = varRef.filter(
      (item) => !item.fetched && !item.is_fetching
    ).length;
    setRemainLoad(itemsToFetch);
    // startLoadingProgress(itemsToFetch);

    for (const item of varRef) {
      if (item.fetched) {
        // console.log(`already fetched ${item.name}`);
        continue;
      } else if (item.is_fetching) {
        console.log(`fetching already ${item.name}`);
        continue;
      }

      try {
        console.log("fetching  " + item.url);
        item.is_fetching = true;

        const resp = await fetch(item.url);
        item.is_fetching = false;
        item.fetched = true;

        if (!resp.ok) {
          item.ok = false;
          console.log(`NO responce: ` + item.name);
        } else {
          const text = await resp.text();
          console.log(">>>>>>response ok: " + item.name);
          item.ok = true;
          console.log("item.time " + item.time);
          item.data = parseLog(item.time, text);
          // console.log(item.data);
          // await sleep(100);
        }
      } catch (error) {
        console.log(`ERR responce: ` + item.name);
        console.log(`error: ` + error);
        item.ok = false;
        item.fetched = true;
      } finally {
        // Уменьшаем счетчик после завершения каждого запроса (успешного или нет)
        setRemainLoad((prev) => prev - 1);
        // updateLoadingProgress();
      }
    }

    console.log("========fetched========");
  };

  const logRefHours = (varRef) => { //log function 
    //TODO: log all hours in var list
    let str = [];
    varRef.map((ref) => {
      str = str + ref.time.getUTCHours().toString() + ".";
    });
    console.log(str);
  };

  const logRefDays = (varRef) => { //log function 
    //TODO: log all hours in var list
    let str = [];
    varRef.map((ref) => {
      console.log(`ref time ${ref.time}`);
      str = str + ref.time.getDate().toString() + ".";
    });
    console.log(str);
  };
  const startLoadingProgress = (total) => {//
    setLoadProgress({ total: total, remain: total });
  };
  const updateLoadingProgress = () => {//
    // Уменьшаем счетчик после завершения каждого запроса (успешного или нет)
    setRemainLoad((prev) => prev - 1);
    setLoadProgress((prev) => ({
      ...prev,
      remain: prev.remain - 1 > 0 ? prev.remain - 1 : 0,
    }));
  };

  const parseLog = (date, text) => {
    const bench1 = new Date();
    const lines = text.trim().split("\n");
    // console.log(`resp: ${url}\n${text}`);
    const parsedData = lines.map((line) => {
      const [secondStr, valueStr] = line.trim().split(/\s+/);
      let seconds = parseInt(secondStr);
      const timeCode = new Date(date.getTime() + seconds * 1000);
      return [timeCode, parseFloat(valueStr)];
    });
    const bench2 = new Date();
    console.log(`Δt parsing: ${bench2.getTime() - bench1.getTime()}`);
    return parsedData;
  };

  const updateGraph = () => {
    console.log("UPDATE GRAPH");
    const varRef = getOrCreate(varName);
  };

  // useEffect(() => {
  //   //add live value
  //   if (live) {
  //     console.log("live value changed: " + liveValue);

  //     setChartData((prev) => [...prev, [new Date(), liveValue]]);
  //   }
  // }, [live, liveValue]);

  const getOrCreate = (name) => {
    if (!dataRef.current.has(name)) {
      dataRef.current.set(name, []);
      console.log("start new Refs.current f or var name " + name);
    }
    return dataRef.current.get(name);
  };

  const goBackward = () => {
    console.clear();
    setTimeA((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setHours(newDate.getHours() - 1);
      return newDate;
    });
    // setTimeB((prevDate) => {
    //   const newDate = new Date(prevDate);
    //   newDate.setHours(newDate.getHours() - 1);
    //   return newDate;
    // });
  };

  const goForward = () => {
    console.clear();
    setTimeA((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setHours(newDate.getHours() + 1);
      return newDate;
    });
    // setTimeB((prevDate) => {
    //   const newDate = new Date(prevDate);
    //   newDate.setHours(newDate.getHours() + 0.5);
    //   return newDate;
    // });
    // console.log("timeA: " + timeA);
  };

  const varButtonPressed = (varName, isPressed) => {
    console.log(`${varName} ${isPressed}`);
  };

  // const renderend = new Date();
  // console.log(`Δt render ${(renderend-renderstart)}`);

  return (
    <div style={{ width: "100%", marginTop: "50px" }}>
      <div className={cl.info}>
        <MySelect
          value={varName}
          onChange={(opt) => setVarName(opt)}
          defaultValue="выберите переменную"
          options={[
            { value: "w1", name: "w1" },
            { value: "w2", name: "w2" },
            { value: "fit5", name: "tank 5" },
            { value: "fit4", name: "tank 4" },
            { value: "fit3", name: "tank 3" },
            { value: "fit2", name: "tank 2" },
            { value: "fit1", name: "tank 1" },
          ]}
        />
      </div>
      <div className={cl.info}>
        {remainLoad > 0 ? <Spinner></Spinner> : <div />}
      </div>
      {varName ? (
        <Chart
          className={cl.chart}
          chartType="LineChart"
          width="100%"
          height="380px"
          data={chartData}
          options={{
            title: varName,
            hAxis: {
              // title: "Время",
              format: "HH:mm:ss", // или просто "short"
              viewWindow: {
                min: timeA,
                max: timeB,
              },
              viewWindowMode: "explicit",
            },
            vAxis: { title: "м3/ч" },
            legend: "none",
            //---------чарт падает при перезапуске страницы-----------
            //---------если startup: true -----------
            animation: {
              duration: 1000, // Animation duration in milliseconds
              easing: "out", // Easing function
              startup: false, // Animate on chart load
            },
            //------------------------------
          }}
          chartLanguage="ru"
        />
      ) : (
        <div>NoVar</div>
      )}
      {/* <div className={cl.controlsWrapper}>
        <button
          onClick={() => {
            console.log("1H");
          }}>
          1H
        </button>
        <button
          onClick={() => {
            console.log("1D");
          }}>
          1D
        </button>
      </div> */}
      <div className={cl.controlsWrapper}>
        <button onClick={() => goBackward()}>Назад</button>
        <button onClick={() => goForward()}>Вперед</button>
      </div>
    </div>
  );

  
  
};

export default GCharts;
